import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" }
const _hoisted_2 = { class: "flex items-center space-x-3 w-full sm:w-auto" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "flex flex-wrap gap-3" }


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerFilters',
  props: {
    search: {},
    status: {},
    brand: {}
  },
  emits: ["update:search", "update:status", "update:brand", "apply", "reset"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

// Auto-filter when search input changes
function handleSearchInput(event: Event) {
  const value = (event.target as HTMLInputElement).value;
  emit('update:search', value);
  emit('apply');
}

// Auto-filter when status changes
function handleStatusChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  emit('update:status', value);
  emit('apply');
}

// Auto-filter when brand changes
function handleBrandChange(event: Event) {
  const value = (event.target as HTMLSelectElement).value;
  emit('update:brand', value);
  emit('apply');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        value: _ctx.search,
        onInput: handleSearchInput,
        type: "search",
        placeholder: "Search customers...",
        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white placeholder-gray-500 focus:ring-2 focus:outline-none shadow-sm w-full sm:min-w-[250px] max-w-sm transition-colors duration-200 brand-focus-ring"
      }, null, 40, _hoisted_3),
      _createElementVNode("select", {
        value: _ctx.status,
        onChange: handleStatusChange,
        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white placeholder-gray-500 focus:ring-2 focus:outline-none shadow-sm transition-colors duration-200 brand-focus-ring"
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("option", { value: "" }, "All Status", -1),
        _createElementVNode("option", { value: "pending" }, "Pending", -1),
        _createElementVNode("option", { value: "active" }, "Active", -1),
        _createElementVNode("option", { value: "rejected" }, "Rejected", -1)
      ]), 40, _hoisted_4),
      _createElementVNode("select", {
        value: _ctx.brand,
        onChange: handleBrandChange,
        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-black text-gray-900 dark:text-white placeholder-gray-500 focus:ring-2 focus:outline-none shadow-sm transition-colors duration-200 brand-focus-ring"
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("option", { value: "" }, "All Brands", -1),
        _createElementVNode("option", { value: "1" }, "Continental", -1),
        _createElementVNode("option", { value: "2" }, "Falken", -1)
      ]), 40, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("button", {
        type: "button",
        class: "text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center space-x-2 shadow-sm",
        style: {"background-color":"var(--brand-primary)"},
        onMouseover: _cache[0] || (_cache[0] = (e) => (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-hover)'),
        onMouseout: _cache[1] || (_cache[1] = (e) => (e.currentTarget as HTMLElement).style.backgroundColor = 'var(--brand-primary)'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reset')))
      }, _cache[5] || (_cache[5] = [
        _createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-5 w-5",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [
          _createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z"
          })
        ], -1),
        _createElementVNode("span", null, "Clear Filters", -1)
      ]), 32)
    ])
  ]))
}
}

})